// src/i18n/en/errorMonitor.ts

const errorMonitor = {
  name: 'Error Monitor',
  title: 'Error Monitor',
  subtitle: 'Real-time error tracking and analysis',
  filters: {
    group: 'Group',
    allGroups: 'All Groups',
    hotel: 'Property',
    allHotels: 'All Properties',
    device: 'Device',
    allDevices: 'All Devices',
    dateFrom: 'From Date',
    dateTo: 'To Date',
    severity: 'Severity',
    allSeverities: 'All Severities',
    category: 'Category',
    allCategories: 'All Categories',
    nature: 'Nature',
    allNatures: 'All Natures',
    errorCode: 'Error Code',
  },
  stats: {
    totalErrors: 'Total Errors',
    genericErrors: 'Generic Errors',
    keyDispenserErrors: 'Key Dispenser Errors',
    paymentErrors: 'Payment Errors',
  },
  trendTitle: 'Error Trends',
  trendSubtitle: 'Error patterns over time',
  chart: {
    errors: 'Errors',
  },
  errorsByDevice: 'Errors by Device',
  recentErrors: 'Recent Errors',
  recentErrorsSubtitle: 'Latest error events',
  views: {
    list: 'List',
    byDevice: 'By Device',
  },
  table: {
    timestamp: 'Timestamp',
    device: 'Device',
    group: 'Group',
    hotel: 'Property',
    type: 'Type',
    errors: 'Errors',
    lastError: 'Last Error',
    category: 'Category',
    severity: 'Severity',
    nature: 'Nature',
    errorCode: 'Error Code',
    error: 'Error',
    description: 'Description',
    recommendation: 'Recommendation',
    reference: 'Reference',
    reservation: 'Reservation',
    room: 'Room',
    metadata: 'Metadata',
    context: 'Context',
    walkInGuest: 'Walk-in guest',
    checkInSource: 'Check-in source',
    journeyInfo: 'Journey Information',
    journeyStatus: 'Status',
    journeyEvents: 'Total events',
    journeyErrors: 'Errors in journey',
    multipleErrorsInJourney: '%{count} error in this journey |||| %{count} errors in this journey',
  },
  noErrors: 'No errors found',
  noData: 'No data available',
  errors: {
    loadFailed: 'Failed to load error statistics',
    loadEventsFailed: 'Failed to load error events',
  },
  help: {
    page: 'Monitor errors occurring on kiosks and dispensers. View the complete error list or group by device to identify problematic equipment.',
  },

  // Bulk delete (SuperAdmin)
  bulkDelete: {
    deleteSelected: 'Delete Selected',
    deleteByFilters: 'Delete all matching filters',
    confirmTitle: 'Confirm Deletion',
    confirmMessage: 'You are about to permanently delete %{count} error. This action cannot be undone. |||| You are about to permanently delete %{count} errors. This action cannot be undone.',
    confirmByFiltersMessage: 'You are about to permanently delete ALL errors matching the current filters. This action cannot be undone.',
    irreversible: 'This action is irreversible. Deleted errors cannot be recovered.',
    deleting: 'Deleting...',
    successMessage: '%{count} error deleted successfully |||| %{count} errors deleted successfully',
    errorMessage: 'Failed to delete errors',
    selected: '%{count} selected',
    clearSelection: 'Clear selection',
    selectAll: 'Select all',
  },

  nature: {
    error: 'Error',
    operational: 'Operational',
    informational: 'Informational',
  },

  errorTypes: {
    generic: {
      name: 'Generic Error',
      description: 'General system error',
    },
    keyDispenser: {
      name: 'Key Dispenser Error',
      description: 'Key dispenser malfunction',
    },
    payment: {
      name: 'Payment Error',
      description: 'Payment processing failure',
    },
    unknown: {
      name: 'Unknown Error',
      description: 'Unknown error type',
    },
  },
  
  sections: {
    s: {
      name: 'Search',
      description: 'Reservation lookup',
    },
    r: {
      name: 'Room Selection',
      description: 'Choose room for walking',
    },
    i: {
      name: 'Identification',
      description: 'Guest information',
    },
    f: {
      name: 'Signature',
      description: 'Sign registration form',
    },
    u: {
      name: 'Upselling',
      description: 'Additional services',
    },
    p: {
      name: 'Payment',
      description: 'Process payment',
    },
    k: {
      name: 'Key Delivery',
      description: 'Dispense room key',
    },
    unknown: {
      name: 'Unknown',
      description: 'Unknown section',
    },
  },
  
  errorMonitor: {
    title: 'Error Monitor',
    subtitle: 'Real-time error tracking and analysis',
    filters: {
      hotel: 'Property',
      allHotels: 'All Properties',
      dateFrom: 'From Date',
      dateTo: 'To Date',
    },
    stats: {
      totalErrors: 'Total Errors',
      genericErrors: 'Generic Errors',
      keyDispenserErrors: 'Key Dispenser Errors',
      paymentErrors: 'Payment Errors',
    },
    trendTitle: 'Error Trends',
    trendSubtitle: 'Error patterns over time',
    chart: {
      errors: 'Errors',
    },
    errorsByDevice: 'Errors by Device',
    recentErrors: 'Recent Errors',
    recentErrorsSubtitle: 'Latest error events',
    table: {
      timestamp: 'Timestamp',
      device: 'Device',
      type: 'Type',
      errors: 'Errors',
      lastError: 'Last Error',
      errorType: 'Error Type',
      section: 'Section',
      errorCode: 'Error Code',
      reservation: 'Reservation',
      room: 'Room',
      context: 'Context',
      walkInGuest: 'Walk-in guest',
      checkInSource: 'Check-in source',
    },
    noErrors: 'No errors found',
    errors: {
      loadFailed: 'Failed to load error statistics',
      loadEventsFailed: 'Failed to load error events',
    },
  },

  abandonmentAnalysis: {
    title: 'Abandonment Analysis',
    subtitle: 'Understand where guests quit the check-in process',
    filters: {
      hotel: 'Property',
      allHotels: 'All Properties',
      dateFrom: 'From Date',
      dateTo: 'To Date',
    },
    summary: {
      totalAbandonments: 'Total Abandonments',
      totalCheckIns: 'Total Check-ins',
      abandonmentRate: 'Abandonment Rate',
    },
    funnelTitle: 'Abandonment by Section',
    funnelSubtitle: 'Where guests are quitting the process',
    avgDuration: 'Avg. time in section',
    noData: 'No abandonment data available',
    byHourTitle: 'Abandonment by Hour',
    byHourSubtitle: 'Hourly abandonment patterns',
    byDeviceTitle: 'Abandonment by Device',
    byDeviceSubtitle: 'Device-level abandonment rates',
    chart: {
      abandonments: 'Abandonments',
      checkIns: 'Check-ins',
      rate: 'Rate',
    },
    legend: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
    },
    table: {
      device: 'Device',
      abandonments: 'Abandonments',
      checkIns: 'Check-ins',
      rate: 'Rate',
      visualization: 'Visualization',
      note: 'Note',
      sortedByRate: 'Devices are sorted by abandonment rate (highest first)',
    },
    errors: {
      loadFailed: 'Failed to load abandonment analysis',
    },
  },
};

export default errorMonitor;
